import { useIntl } from 'react-intl';
import { EAuthRoutes, FSEAuthRoutes } from '@agco-onedigital/ecosystem-lib-frontend-utils';
import { commonMessages } from 'messages';
import { useLaunchDarkly } from '../../../store/LaunchDarkly';
import { ISidebarProps, IUserMenuProps } from './types';
import { useDataAndPrivacySidbarItem } from './utils';

const menuMessages = commonMessages.menu;

export const useUserData = ({ user, isDataAndPrivacyPageEnabled, handleLogOut }: ISidebarProps) => {
  const { formatMessage } = useIntl();
  const launchDarkly = useLaunchDarkly();
  const repairManualsEnabled = !!launchDarkly['repair-manuals-enabled'];

  const purchaseHistoryItem = {
    label: formatMessage(menuMessages.purchaseHistory),
    key: 'purchase-history',
    to: `${FSEAuthRoutes.PURCHASE_HISTORY}`,
    testId: 'sidebar-purchase-history',
  };

  const PURCHASE_HISTORY = repairManualsEnabled ? [purchaseHistoryItem] : [];

  const userData: IUserMenuProps = {
    email: user.email,
    username: `${user.firstName} ${user.lastName}`,
    profileImageUrl: user.profileImageUrl,
    basePath: EAuthRoutes.USER,
    items: [
      {
        key: 'log-in-and-security',
        label: formatMessage(menuMessages.logInAndSecurity),
        to: `${EAuthRoutes.USER}${EAuthRoutes.LOGIN_AND_SECURITY}`,
        testId: 'sidebar-log-in-and-security',
      },
      ...PURCHASE_HISTORY,
      {
        key: 'personal-data',
        label: formatMessage(menuMessages.personalData),
        to: `${EAuthRoutes.USER}${EAuthRoutes.PERSONAL_DATA}`,
        testId: 'sidebar-personal-data',
      },
      {
        key: 'business-information',
        label: formatMessage(menuMessages.businessAccounts),
        to: EAuthRoutes.USER_BUSINESS_ACCOUNTS,
        testId: 'sidebar-business-information',
      },
      ...useDataAndPrivacySidbarItem(isDataAndPrivacyPageEnabled),
      {
        label: formatMessage(menuMessages.logout),
        testId: 'sidebar-logout',
        onClick: handleLogOut,
        key: 'logout',
      },
    ],
  };
  return userData;
};
